/**
 * How the builder reflows.
 *
 * both — elements reduce vertically and horizontally.
 * compact — as `both`, plus a height trigger: a wide but short window also gets
 *   the reduced settings.
 */
export type ResponsiveType = 'both' | 'compact';
/** Not offered in the options panel for now — nothing reads it yet. */
export type SettingsVariant = 'default' | 'dividers';

/**
 * How the top bar offers the chat, and what the row does when it closes. The
 * options panel numbers these by position, so its order is the one to trust —
 * these names stay put when that order changes.
 *
 * closeCross — the Chat button gives way to a cross at the chat's far edge, and
 *   closing the chat hands the row back to the settings bar.
 * toggleButton — one button that reads Chat, then Hide while the chat is open.
 * selectionOnly — the cross as above, but closing the chat gives the whole row
 *   to the email. The settings bar only appears once something is selected.
 * menuAndClose — closeCross with a hamburger for the sidebar, and the cross kept
 *   beside it rather than out at the chat's far edge.
 */
export type NavigationVariant = 'closeCross' | 'toggleButton' | 'selectionOnly' | 'menuAndClose';

export type PrototypeOptions = {
  responsiveType: ResponsiveType;
  settingsVariant: SettingsVariant;
  navigationVariant: NavigationVariant;
};

export const defaultPrototypeOptions: PrototypeOptions = {
  responsiveType: 'both',
  settingsVariant: 'default',
  navigationVariant: 'closeCross',
};
